/**
 * The credits-state additional fields carried by EVERY personal-sale / credits CTA BI event
 * (`personal_sale_banner_cta`, `personal_sale_banner_dismiss`, `upgrade_credits` / `get_more_credits`),
 * so a funnel can slice a click by the account's credit situation.
 *
 * Import-free on purpose, so a unit test can exercise it without dragging the app's graph in (same as the
 * sibling `credits-widget-bi.ts`).
 *
 * ⚠️ **A THREE-SURFACE contract.** The same three keys and value vocabulary are sent by iOS
 * (`creditsStateBiFields` in `CreditsWidgetState.swift`) and Android (`creditsStateBiFields` in
 * `CreditsWidgetState.kt`) — a funnel that cannot join web to the phones is three numbers, not one. Keep
 * the strings identical; change all three together.
 *
 * FT-INDEPENDENT by construction: the caller passes the credit state before the flag gate (`useCreditsState`, i.e.
 * `computeCreditsWidgetState({ enabled: true, … })`), so `credits_state` / `credits_pool` are the same
 * whether or not the low/out-credits widget flag is on. `plan_tier` is `free` → `max_plus` → `paid`.
 */
export function creditsStateBiFields(input: {
  level: 'none' | 'low' | 'out';
  pool: 'daily' | 'monthly';
  isFreePlan: boolean;
  isMaxPlus: boolean;
}): Record<string, string> {
  return {
    credits_state: input.level,
    credits_pool: input.pool,
    plan_tier: input.isFreePlan ? 'free' : input.isMaxPlus ? 'max_plus' : 'paid',
  };
}
